export function timeAgo(iso) {
  if (!iso) return "";
  const then = new Date(iso).getTime();
  if (Number.isNaN(then)) return "";
  const days = Math.floor((Date.now() - then) / 86400000);
  if (days <= 0) return "today";
  if (days === 1) return "yesterday";
  if (days < 7) return `${days} days ago`;
  if (days < 30) return `${Math.floor(days / 7)} week${days < 14 ? "" : "s"} ago`;
  if (days < 365) return `${Math.floor(days / 30)} month${days < 60 ? "" : "s"} ago`;
  return `${Math.floor(days / 365)} year${days < 730 ? "" : "s"} ago`;
}

// Freshness label for Data-Hub cards. Built-in charts show their source year so
// they never look stale; admin-added items show when they were added.
export function freshnessLabel(item) {
  if (item.builtin) return item.source_date ? `Data · ${item.source_date}` : null;
  if (!item.created_at) return null;
  return `Added ${timeAgo(item.created_at)}`;
}
